import React from 'react';
import { ArrowRight } from 'lucide-react';
import { heroImages, whatsappLink } from '../data/mock';

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 lg:pt-36 pb-24 overflow-hidden">
      {/* Decorative giant A */}
      <span className="pointer-events-none select-none absolute right-0 bottom-0 font-serif italic text-[38rem] leading-none text-[color:var(--gold-400)]/[0.04] -mr-24">
        A
      </span>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="animate-fade-up">
          <p className="text-[10px] md:text-[11px] tracking-widest-2 text-[color:var(--gold-400)] uppercase mb-8">
            Social Media · Videomaker · Fotógrafa · Belo Horizonte
          </p>
          <h1 className="font-serif text-[3.4rem] md:text-[4.5rem] lg:text-[5.2rem] leading-[1.02] text-[color:var(--cream-100)]">
            Transforme{' '}
            <span className="italic text-[color:var(--gold-400)]">suas redes</span>
            {' '}em <br />autoridade.
          </h1>
          <p className="mt-8 max-w-lg text-[color:var(--cream-100)]/75 text-base md:text-lg leading-relaxed">
            Estratégia, imagem e conteúdo com alma para marcas e profissionais
            que querem parar de postar por postar e começar a ser referência.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-6">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 pl-7 pr-3 py-3.5 rounded-full bg-[color:var(--gold-500)] text-[color:var(--brown-900)] font-medium tracking-wider text-xs uppercase hover:bg-[color:var(--gold-400)] transition-colors"
            >
              Quero falar com a Ana
              <span className="w-9 h-9 rounded-full bg-[color:var(--brown-900)] text-[color:var(--gold-400)] flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <ArrowRight size={14} />
              </span>
            </a>
            <a
              href="#servicos"
              className="text-[11px] tracking-widest-2 uppercase text-[color:var(--cream-100)] border-b border-[color:var(--gold-400)]/50 pb-1 hover:border-[color:var(--gold-400)] transition"
            >
              Conhecer o trabalho
            </a>
          </div>
        </div>

        <div className="relative flex justify-center lg:justify-end animate-fade-up">
          <div className="arch-frame w-[300px] md:w-[380px] lg:w-[440px] aspect-[3/4.4] shadow-2xl">
            <img
              src={heroImages.main}
              alt="Ana Rodrigues"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-10 flex justify-end">
        <div className="flex flex-col items-center text-[color:var(--cream-100)]/60">
          <span className="text-[10px] tracking-widest-2 uppercase mb-2">Role</span>
          <span className="w-px h-16 bg-[color:var(--gold-400)]/50"></span>
        </div>
      </div>
    </section>
  );
}
